import arrayIndexSize from './arrayIndexSize'
import capitalizeCamelCaseText from './capitalizeCamelCaseText'
import capitalizeText from './capitalizeText'
import convertFormDataToArray from './convertFormDataToArray'
import countText from './countText'
import datePickerPastBlocker from './datePickerPastBlocker'
import daysTillOtherDate from './daysTillOtherDate'
import dig from './dig'
import documentName from './documentName'
import getColorByVariant from './getColorByVariant'
import getIconByVariant from './getIconByVariant'
import insertArrayAt from './insertArrayAt'
import isArrayOf from './isArrayOf'
import isEmpty from './isEmpty'
import percentage from './percentage'
import reduceRoutesToArray from './reduceRoutesToArray'
import splitFirstOccurrence from './splitFirstOccurrence'
import unflattenObject from './unflattenObject'
import upperText from './upperText'
import validUrl from './validUrl'
import yearsAhead from './yearsAhead'

const functions = {
  arrayIndexSize,
  capitalizeCamelCaseText,
  capitalizeText,
  convertFormDataToArray,
  countText,
  datePickerPastBlocker,
  daysTillOtherDate,
  dig,
  documentName,
  getColorByVariant,
  getIconByVariant,
  insertArrayAt,
  isArrayOf,
  isEmpty,
  percentage,
  reduceRoutesToArray,
  splitFirstOccurrence,
  unflattenObject,
  upperText,
  validUrl,
  yearsAhead,
}

export default functions
